<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Manage LRT 2nd Level Approver</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Table List -->
    <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
      <table class="table table-bordered custom-table mb-0">
        <thead class="thead-light">
          <tr>
            <th class="text-center" style="width: 40%">Employee</th>
            <th class="text-center" style="width: 60%">Cost Centres</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(app, i) in approvers" :key="i">
            <td style="width: 40%">
              <Select2 v-model="app.UserId" :options="employees" />
            </td>
            <td style="position: relative; width: 60%">
              <div class="costcenter-container">
                <template v-for="(item, j) in costCenters">
                  <input
                    :id="'cc_' + i + '_' + j"
                    type="checkbox"
                    v-model="app.CostCenters"
                    :key="'ccCheckbox' + i + j"
                    :value="item.CostCentreName"
                  />
                  <label :for="'cc_' + i + '_' + j" :key="'ccLabel' + i + j">
                    {{ item.CostCentreCode }} - {{ item.CostCentreName }}
                  </label>
                </template>
              </div>
              <span
                @click="removeApprover(i)"
                style="
                  position: absolute;
                  right: -8px;
                  top: 25px;
                  color: #ff0000;
                  cursor: pointer;
                "
              >
                <i class="fa fa-minus-circle"></i>
              </span>
            </td>
          </tr>

          <tr>
            <td class="text-center" colspan="2">
              <button
                type="button"
                class="btn btn-primary"
                @click="addApprover"
              >
                <i class="fa fa-plus"></i> Add Approver
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- /Table List -->

    <!-- Button Save -->
    <div class="row mt-4">
      <div class="col-md-12">
        <button @click="save" type="button" class="btn btn-primary">
          <i class="fa fa-save"></i>
          Save
        </button>
      </div>
    </div>
    <!-- /Button Save -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
  data() {
    return {
      approvers: [],
      costCenters: [],
      employees: [],
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  methods: {
    addApprover() {
      this.approvers.push({
        UserId: "00000000-0000-0000-0000-000000000000",
        CostCenters: [],
      });
    },
    removeApprover(index) {
      this.approvers.splice(index, 1);
    },
    getEmployees() {
      let param = { Token: this.token };
      this.$store.state.isLoading = true;
      API.getEmployees(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employees = response.data.record;
            this.employees.unshift({
              id: "00000000-0000-0000-0000-000000000000",
              text: "-- Please Select --",
            });
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getFwaApprovers() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getFwaApprovers(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) this.approvers = response.data.record;
            this.costCenters = response.data.costCenters;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      //check duplicate date
      let messages = [];
      for (let item of this.approvers) {
        if (item.UserId) {
          let records = this.approvers.filter((c) => c.UserId == item.UserId);
          if (records && records.length > 1) {
            let emp = this.employees.find((c) => c.id == item.UserId);
            if (emp) {
              messages.push("Employee: " + emp.text + " is duplicated.");
            }
          }
        }
      }
      if (messages.length > 0) {
        messages = [...new Set(messages)];
        this.$swal(messages.join("\n"), { icon: "error" });
        return;
      }

      let param = {
        Token: this.token,
        Approvers: this.approvers,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the approvers?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveFwaApprovers(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              this.approvers = [];
              this.getFwaApprovers();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
  created() {
    if (this.role != "admin") this.$router.replace({ name: "home" });
    this.getEmployees();
    this.getFwaApprovers();
  },
};
</script>

<style scoped>
table {
  width: 1170px !important;
}
.table.custom-table > tbody > tr > td {
  padding-right: 5px !important;
  padding-left: 10px !important;
}
.costcenter-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
}
.costcenter-container label {
  margin-bottom: -0.2rem;
  width: 320px;
  cursor: pointer;
  word-spacing: -2px;
}
.costcenter-container input[type="checkbox"] {
  margin-right: 3px;
  cursor: pointer;
}

@media only screen and (max-width: 1300px) {
  .costcenter-container label {
    width: 480px;
  }
  table {
    width: 872px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Fwa/FwaApprover.vue